import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SearchService } from '../../../services/search/search.service';

// Hosts a registry create form inside the bottom split-drawer slot, opened via
// SemSelect quick-create. v1 implementation embeds the existing form route in
// an iframe; the parent listens for postMessage events from the embedded page.
@Component({
    selector: 'sem-quick-create-host',
    templateUrl: './sem-quick-create-host.component.html',
    styleUrls: ['./sem-quick-create-host.component.css'],
    standalone: false
})
export class SemQuickCreateHostComponent implements OnInit, OnDestroy {

    iframeUrl: SafeResourceUrl | null = null;
    headerTitle: string = '';
    headerMode: 'create' | 'view' = 'create';
    fullPageUrl: string = '';
    private subscription: Subscription | null = null;
    private messageHandler = (ev: MessageEvent) => this.onIframeMessage(ev);

    constructor(
        public searchService: SearchService,
        private sanitizer: DomSanitizer,
        private zone: NgZone,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        const cfg = this.searchService.quickCreateConfig;
        if (cfg) {
            this.applyConfig();
        }
        this.subscription = this.searchService.quickCreate$.subscribe(() => {
            if (this.searchService.quickCreateConfig) {
                this.applyConfig();
            } else {
                this.iframeUrl = null;
                this.headerTitle = '';
            }
            this.cdr.detectChanges();
        });
        window.addEventListener('message', this.messageHandler);
        document.getElementsByClassName('item-container')[0]?.classList.add('splitted-view');
    }

    ngOnDestroy(): void {
        window.removeEventListener('message', this.messageHandler);
        document.getElementsByClassName('item-container')[0]?.classList.remove('splitted-view');
        this.subscription?.unsubscribe();
    }

    private applyConfig() {
        const cfg = this.searchService.quickCreateConfig!;
        const sep = cfg.routePath.includes('?') ? '&' : '?';
        const url = `${cfg.routePath}${sep}embed=quickCreate`;
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.headerTitle = cfg.title || '';
        this.headerMode = cfg.mode || 'create';
        this.fullPageUrl = cfg.routePath;
    }

    openFullPage() {
        if (this.fullPageUrl) {
            window.open(this.fullPageUrl, '_blank');
        }
    }

    private onIframeMessage(ev: MessageEvent) {
        if (ev.origin !== window.location.origin) return;
        const data = ev.data;
        if (!data || typeof data !== 'object') return;
        if (data.type === 'wg.quickCreate.saved') {
            const cfg = this.searchService.quickCreateConfig;
            // Run callback inside Angular zone — message events arrive outside it.
            this.zone.run(() => {
                cfg?.onSaved?.(data.entry);
                this.searchService.closeQuickCreate();
            });
        } else if (data.type === 'wg.quickCreate.canceled') {
            const cfg = this.searchService.quickCreateConfig;
            this.zone.run(() => {
                cfg?.onCancel?.();
                this.searchService.closeQuickCreate();
            });
        }
    }

    close() {
        const cfg = this.searchService.quickCreateConfig;
        cfg?.onCancel?.();
        this.searchService.closeQuickCreate();
    }
}
